import React, { KeyboardEvent, useEffect, useRef } from 'react';
import { ForgeTextField } from '@tylertech/forge-react';
import PrivateFieldIcon from '../PrivateFieldIcon/PrivateFieldIcon';

interface FieldLike {
  name: string;
  value: string | undefined;
  placeholder?: string;
  label?: string;
  isRequired?: boolean;
  disabled?: boolean;
}

interface Props {
  id?: string;
  dataTestId?: string;
  field: FieldLike;
  inErrorState: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur?: () => void;
  handleFocus?: () => void;
  handleKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  focusOnMount?: boolean;
  isRequired?: boolean;
  isPrivate?: boolean;
}
const TextInput = ({ handleChange, handleFocus, handleBlur, handleKeyDown, field, focusOnMount, id, inErrorState, isRequired, isPrivate, dataTestId }: Props) => {
  const ref = useRef<HTMLInputElement>(null);
  let classes = ['dsmui-text-input'];

  useEffect(() => {
    if (focusOnMount && ref.current) {
      ref.current!.focus(); // tsc is very mean and does not believe it's not actually null even though there's a check.
    }
  }, []);

  if (inErrorState) {
    classes = [...classes, 'text-input-error', 'dsmui-text-input-error'];
  }
  return (
    <ForgeTextField invalid={inErrorState} floatLabelType="always" required={isRequired}>
      { isPrivate && <PrivateFieldIcon/>}
      <input
        data-testid={dataTestId}
        type="text"
        ref={ref}
        id={id ?? field.name}
        name={field.name}
        value={field.value}
        placeholder={field.placeholder}
        aria-label={field.label || field.name}
        aria-required={field.isRequired}
        className={classes.join(' ')}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={handleFocus}
        onKeyDown={handleKeyDown}
        disabled={field.disabled}
      />
      <label htmlFor={id ?? field.name} slot="label">{ field.label || field.name }</label>
    </ForgeTextField>
  );
};

export default TextInput;
